import { useEffect } from 'react';
import { useWebgate } from '@xvia/webgate-connect';

import { setApiAccessToken } from '@/infrastructure/api/interceptors';

/** Propaga o accessToken do portal para o cliente HTTP (fora do React). */
export function WebgateApiBridge() {
  const { accessToken } = useWebgate();

  useEffect(() => {
    setApiAccessToken(accessToken);
  }, [accessToken]);

  return null;
}
